export default "__VITE_ASSET__1324a0f9__"